const schoolBus = [
  // ── DANGER ZONES ──────────────────────────────────────────────────────────────
  {
    id: "sb001",
    question: "The 'danger zone' around a school bus is defined as:",
    options: [
      "The area directly behind the bus only",
      "The area within 10 feet of the bus on all sides",
      "The area within 30 feet in front of the bus only",
      "The area within 5 feet of the bus on all sides",
    ],
    answer: 1,
    explanation: "The danger zone extends 10 feet on all sides of the school bus — front, rear, and both sides. This is where students are most at risk of being struck.",
  },
  {
    id: "sb002",
    question: "Which area around a school bus is considered the MOST dangerous for students?",
    options: [
      "Behind the bus",
      "On the right side of the bus",
      "Directly in front of the bus",
      "On the left side of the bus",
    ],
    answer: 2,
    explanation: "The area directly in front of the bus is the most dangerous blind spot. A child who falls or bends down there is invisible to the driver.",
  },
  {
    id: "sb003",
    question: "How far in front of the school bus should a student walk before crossing the road?",
    options: [
      "5 feet — just clear of the front bumper",
      "At least 10 feet in front of the bus so the driver can see them",
      "At least 6 feet in front of the bus",
      "Students should cross behind the bus, not in front",
    ],
    answer: 1,
    explanation: "Students must walk at least 10 feet in front of the bus before crossing — far enough that the driver can clearly see them from the driver's seat.",
  },
  {
    id: "sb004",
    question: "A student drops a glove near the right front wheel of the school bus. You should:",
    options: [
      "Tell the student to quickly pick it up and then immediately move the bus",
      "Wait until the student retrieves the item, is visible, and at least 10 feet away before moving",
      "Honk once to alert the student and proceed",
      "Ask another student to pick it up",
    ],
    answer: 1,
    explanation: "A student bending down in the danger zone is invisible to the driver. Never move until the child is upright, visible, and safely away from the bus.",
  },
  {
    id: "sb005",
    question: "Why must students walk to a point at least 10 feet from the bus before crossing?",
    options: [
      "To comply with school district policy",
      "Because the driver cannot see any person who is closer than 10 feet in front of the bus",
      "To allow the bus to pull forward before they cross",
      "Because the stop arm only extends 10 feet",
    ],
    answer: 1,
    explanation: "The driver's forward blind spot extends approximately 10 feet from the front bumper. Students must be beyond this before crossing so the driver can confirm it is safe.",
  },
  // ── LOADING AND UNLOADING ─────────────────────────────────────────────────────
  {
    id: "sb006",
    question: "Before opening the door to load or unload students, a school bus driver must first:",
    options: [
      "Activate the red flashing lights and stop arm, then check mirrors",
      "Just open the door so students can board quickly",
      "Check only the left mirror",
      "Turn on the hazard lights",
    ],
    answer: 0,
    explanation: "Activate amber then red lights, extend the stop arm, and check ALL mirrors before opening the door — confirm the area is clear of hazards.",
  },
  {
    id: "sb007",
    question: "After loading students, before moving the bus, the driver must verify that:",
    options: [
      "All students are seated and the door is fully closed",
      "The engine temperature is normal",
      "Only the front seats are occupied",
      "Students have shown their bus passes",
    ],
    answer: 0,
    explanation: "Check that all students are seated and secure, the entry door is completely closed, and all mirrors are clear before moving the bus.",
  },
  {
    id: "sb008",
    question: "When unloading students, you should NOT allow a student to cross the road until:",
    options: [
      "The student is ready and walks briskly",
      "All stop arm and red lights are activated AND you have confirmed all approaching traffic has stopped",
      "No cars are visible within 100 feet",
      "The last student has exited the bus",
    ],
    answer: 1,
    explanation: "Do not wave students across until you have verified the stop arm is out, red lights are flashing, and ALL traffic in both directions has completely stopped.",
  },
  {
    id: "sb009",
    question: "A student who must cross the road after exiting the bus should cross:",
    options: [
      "Immediately after stepping off the bus",
      "Behind the bus where traffic can see them",
      "In front of the bus — at least 10 feet ahead — after the driver signals it is safe",
      "At the nearest traffic light",
    ],
    answer: 2,
    explanation: "Students cross in front of the bus (at least 10 feet ahead), after making eye contact with the driver and receiving the signal that it is safe to cross.",
  },
  {
    id: "sb010",
    question: "While students are loading or unloading, the school bus driver should:",
    options: [
      "Watch only the students boarding at the door",
      "Continuously monitor all mirrors and the area around the bus for hazards",
      "Fill out paperwork to use the time efficiently",
      "Only watch the left side mirror",
    ],
    answer: 1,
    explanation: "The driver must continuously scan all mirrors — left, right, and front — to monitor all students and the surrounding area during loading and unloading.",
  },
  {
    id: "sb011",
    question: "If a student approaching the school bus stop runs into the road unexpectedly, the driver should:",
    options: [
      "Sound the horn and proceed",
      "Stop immediately and wait until the student is safely on board and seated",
      "Slow to 5 mph and open the door",
      "Flash the headlights to warn the student",
    ],
    answer: 1,
    explanation: "Any unexpected movement by a student requires an immediate stop. Never move when a student is in or near the danger zone.",
  },
  // ── STOP ARM AND FLASHING LIGHTS ──────────────────────────────────────────────
  {
    id: "sb012",
    question: "Amber (yellow) flashing lights on a school bus signal that:",
    options: [
      "The bus is broken down",
      "The bus is about to stop to load or unload students — traffic should prepare to stop",
      "Students are already loading",
      "The bus is turning left",
    ],
    answer: 1,
    explanation: "Flashing amber lights warn approaching drivers that the bus is about to stop. They are activated 100–500 feet before the stop (depending on the speed limit) so drivers have time to slow down.",
  },
  {
    id: "sb013",
    question: "Red flashing lights and an extended stop arm on a school bus mean:",
    options: [
      "The bus is in emergency",
      "Traffic approaching from all directions must stop — do not pass",
      "The bus is turning",
      "Only traffic behind the bus must stop",
    ],
    answer: 1,
    explanation: "Red flashing lights and the stop arm require ALL traffic from both directions to stop (except on divided highways with a physical median barrier).",
  },
  {
    id: "sb014",
    question: "On a two-lane road, when a school bus is loading students with red lights flashing, traffic on BOTH sides of the road must:",
    options: [
      "Slow to 15 mph",
      "Stop — passing a stopped school bus is illegal in all states",
      "Only stop if within 200 feet",
      "Proceed only if no students are visible",
    ],
    answer: 1,
    explanation: "On a two-lane road (undivided highway), all traffic from both directions must stop when a school bus is loading or unloading with red lights activated.",
  },
  {
    id: "sb015",
    question: "On a divided highway with a physical median barrier, approaching traffic on the OPPOSITE side of the barrier from the school bus must:",
    options: [
      "Stop — all divided highways require stopping",
      "Slow to 25 mph and proceed with caution",
      "Not stop — the physical barrier separates traffic flows",
      "Stop only if they see students crossing",
    ],
    answer: 2,
    explanation: "When a physical barrier (raised median, guardrail) separates traffic, vehicles on the far side do not have to stop. A painted line alone is NOT a physical barrier.",
  },
  {
    id: "sb016",
    question: "The stop arm on a school bus is located:",
    options: [
      "On the front of the bus",
      "On the right side of the bus",
      "On the left side of the bus, behind the driver's window",
      "On the rear of the bus",
    ],
    answer: 2,
    explanation: "The stop arm swings out from the left (driver's side) of the bus and displays red flashing lights to signal all traffic to stop.",
  },
  // ── MIRROR SYSTEMS ────────────────────────────────────────────────────────────
  {
    id: "sb017",
    question: "School buses are required to have a mirror system that allows the driver to:",
    options: [
      "See only the road behind the bus",
      "See all areas around the bus including the danger zones on all sides",
      "See only passengers inside the bus",
      "See only the right side of the bus",
    ],
    answer: 1,
    explanation: "School bus mirror systems (cross-view, flat, convex, and inside mirrors) must cover all danger zones so no student can be hidden from the driver's view.",
  },
  {
    id: "sb018",
    question: "Convex mirrors on a school bus are used to:",
    options: [
      "Provide a straight, accurate view of traffic behind",
      "Provide a wide-angle view of the sides and rear — they show a larger area but make objects appear farther away",
      "Show the interior of the bus",
      "Magnify close objects for better inspection",
    ],
    answer: 1,
    explanation: "Convex mirrors provide a wide field of view along the sides and rear but distort distance — objects appear farther than they are. They expand coverage of the danger zone.",
  },
  {
    id: "sb019",
    question: "The crossover (cross-view) mirror on a school bus is used to:",
    options: [
      "See traffic behind the bus",
      "See the area directly in front of the bus and the right front corner blind spot",
      "See the left rear of the bus",
      "Monitor student behavior inside the bus",
    ],
    answer: 1,
    explanation: "The cross-view (or overhead front) mirror lets the driver see the danger zone directly in front of the bus and the right front corner — the most critical blind spot.",
  },
  // ── RAILROAD CROSSINGS ───────────────────────────────────────────────────────
  {
    id: "sb020",
    question: "At a railroad crossing, a school bus driver must:",
    options: [
      "Stop only if a train is visible or audible",
      "Always stop 15–50 feet from the nearest rail, open the service door, look and listen, then cross only when safe",
      "Slow to 15 mph and proceed",
      "Stop only at crossings without signals",
    ],
    answer: 1,
    explanation: "School buses must ALWAYS stop at railroad crossings (15–50 feet from the nearest rail), open the service door to listen, look both ways, and cross only when clear — no exceptions.",
  },
  {
    id: "sb021",
    question: "Why does a school bus driver open the service door at a railroad crossing?",
    options: [
      "To allow students to exit in case of emergency",
      "To reduce wind resistance",
      "To hear approaching trains more clearly",
      "It is required only at crossings without active signals",
    ],
    answer: 2,
    explanation: "Opening the door eliminates road noise inside the bus so the driver can hear an approaching train. This is required even if signals are present.",
  },
  {
    id: "sb022",
    question: "A school bus may proceed through a railroad crossing without stopping if:",
    options: [
      "The driver can see clearly in both directions for at least ¼ mile",
      "No traffic is behind the bus",
      "An 'Exempt' sign is posted indicating the track is not in use",
      "The crossing has active gates and signals",
    ],
    answer: 2,
    explanation: "The only exception to the mandatory stop requirement is a crossing marked with an official 'Exempt' sign, indicating the tracks are abandoned or no longer in use.",
  },
  {
    id: "sb023",
    question: "When crossing railroad tracks, a school bus driver must NOT:",
    options: [
      "Turn off the radio",
      "Change gears while the bus is on the tracks",
      "Open the service door",
      "Look in both directions",
    ],
    answer: 1,
    explanation: "Never shift gears on the tracks — a gear change could stall the engine, leaving the bus stranded on the tracks. Cross in a gear that carries you fully across without shifting.",
  },
  {
    id: "sb024",
    question: "Before a school bus crosses railroad tracks, the driver must make sure there is enough space on the other side to:",
    options: [
      "Allow the rear of the bus to clear by at least 5 feet",
      "Completely clear all tracks and be at least 15 feet past the last rail before stopping",
      "Stop traffic on the other side",
      "Allow students to exit safely",
    ],
    answer: 1,
    explanation: "Never start across tracks unless there is enough room on the far side for the entire bus to clear the tracks — getting caught part-way across is extremely dangerous.",
  },
  // ── EMERGENCY EVACUATION ─────────────────────────────────────────────────────
  {
    id: "sb025",
    question: "A school bus driver should evacuate students when:",
    options: [
      "Whenever a student requests it",
      "Only if the bus catches fire",
      "When the danger of staying on the bus is greater than the danger of leaving — fire, hazmat, structural failure, or being hit",
      "Only when a law enforcement officer orders it",
    ],
    answer: 2,
    explanation: "Evacuate when remaining on the bus is more dangerous than leaving. Situations include fire, hazmat exposure, risk of collision, or the bus sinking into water.",
  },
  {
    id: "sb026",
    question: "During an emergency evacuation of a school bus, students should be directed to:",
    options: [
      "Scatter in all directions to get away from the bus quickly",
      "A safe location at least 100 feet away from the bus, off the road and away from traffic",
      "The nearest building",
      "Stay near the bus until help arrives",
    ],
    answer: 1,
    explanation: "Direct all students to a predetermined safe location — at least 100 feet from the bus, away from traffic, and upwind if there is a hazmat or fire risk.",
  },
  {
    id: "sb027",
    question: "When evacuating through the rear emergency exit, students should:",
    options: [
      "Jump down as quickly as possible",
      "Exit one at a time, using helpers stationed at the bottom to assist smaller students",
      "Use the rear exit only as a last resort after all other exits are tried",
      "Older students jump first to catch younger students",
    ],
    answer: 1,
    explanation: "Assign helpers at the bottom of the rear exit to assist students who cannot jump down safely. Students exit one at a time in an orderly fashion.",
  },
  {
    id: "sb028",
    question: "After an emergency evacuation, the driver should:",
    options: [
      "Leave the students and go for help",
      "Account for every student, keep them together at the safe location, and contact dispatch or 911",
      "Attempt to move the bus before calling for help",
      "Allow students to call their parents and leave",
    ],
    answer: 1,
    explanation: "After evacuation, count all students, keep them together at the safe location, and immediately contact dispatch and emergency services.",
  },
  // ── POST-TRIP INSPECTION ──────────────────────────────────────────────────────
  {
    id: "sb029",
    question: "After every school bus trip, the driver MUST:",
    options: [
      "Complete the fuel log",
      "Physically walk through the entire bus to check for sleeping or hiding children",
      "Report arrival time to the school",
      "Clean the interior of the bus",
    ],
    answer: 1,
    explanation: "A post-trip walk-through is a legal requirement. Children have died because drivers did not check. Walk from front to back and visually inspect every seat.",
  },
  {
    id: "sb030",
    question: "The purpose of the school bus post-trip inspection is specifically to:",
    options: [
      "Check for mechanical problems",
      "Ensure no child has been left on the bus",
      "Verify the fuel level",
      "Record passenger counts for billing",
    ],
    answer: 1,
    explanation: "The post-trip inspection is a child-safety requirement. Children may fall asleep or hide and can die from heat exposure if left on a bus.",
  },
  {
    id: "sb031",
    question: "A child is found sleeping on the bus during the post-trip inspection. The driver should:",
    options: [
      "Wake the child and let them walk home",
      "Gently wake the child, ensure they are unharmed, contact school officials and the child's parents, and follow district protocol",
      "Call 911 immediately without checking on the child first",
      "Leave the child and call the school from outside",
    ],
    answer: 1,
    explanation: "Wake and assess the child, then immediately notify school officials and parents. Follow your district's protocol — do not leave the child unattended.",
  },
  // ── PRE-TRIP INSPECTION (SCHOOL BUS SPECIFIC) ────────────────────────────────
  {
    id: "sb032",
    question: "During a school bus pre-trip inspection, mirrors must be checked to ensure they are:",
    options: [
      "Clean and unobstructed, properly adjusted to eliminate all blind spots around the bus",
      "Only adjusted for highway driving",
      "Adjusted so the driver can see the sides of the bus",
      "Only the inside mirrors need to be checked",
    ],
    answer: 0,
    explanation: "All mirrors — flat, convex, and cross-view — must be clean, undamaged, and properly adjusted to provide complete coverage of all danger zones.",
  },
  {
    id: "sb033",
    question: "Which school bus-specific safety device must be checked during the pre-trip inspection?",
    options: [
      "The coffee maker",
      "The stop arm — that it extends and retracts properly and the lights function",
      "The GPS system",
      "Only the horn",
    ],
    answer: 1,
    explanation: "The stop arm mechanism and its flashing lights must be tested every pre-trip. A malfunctioning stop arm is a serious safety defect that must be corrected before the bus goes in service.",
  },
  {
    id: "sb034",
    question: "The emergency exits on a school bus must be checked to verify they:",
    options: [
      "Are locked from the outside",
      "Open and close properly from inside and outside, are clearly marked, and alarms sound when opened",
      "Are only accessible from the inside",
      "Only need to be checked weekly",
    ],
    answer: 1,
    explanation: "Emergency exits must open from both inside and outside, be clearly labeled, and emergency exit alarms must function. These are life-safety items checked every pre-trip.",
  },
  {
    id: "sb035",
    question: "What must a school bus driver check regarding the strobe light (if equipped) during pre-trip?",
    options: [
      "Only that it is installed — function is checked monthly",
      "That it operates correctly — it improves visibility in adverse weather",
      "That it does not interfere with the stop arm lights",
      "Strobe lights are optional and do not need inspection",
    ],
    answer: 1,
    explanation: "Strobe lights increase the visibility of the school bus in fog, rain, and low light. If equipped, verify it operates correctly during the pre-trip inspection.",
  },
  // ── PUPIL MANAGEMENT ─────────────────────────────────────────────────────────
  {
    id: "sb036",
    question: "A student is being disruptive and distracting the driver. The correct action is to:",
    options: [
      "Yell at the student while continuing to drive",
      "Pull over safely, address the situation, and resume driving once order is restored",
      "Ignore the behavior and continue driving",
      "Stop suddenly to shock the student into compliance",
    ],
    answer: 1,
    explanation: "A distracted driver is a safety threat. Pull over to a safe location, address the disruption, and only resume driving when the situation is resolved.",
  },
  {
    id: "sb037",
    question: "If a fight breaks out on the school bus, the driver should:",
    options: [
      "Physically intervene to stop the fight while driving",
      "Pull over, activate hazard lights, attempt to verbally separate the students, and immediately notify dispatch",
      "Continue driving and make a PA announcement",
      "Stop the bus in the travel lane and call for help",
    ],
    answer: 1,
    explanation: "Stop safely. A driver who tries to intervene physically while driving endangers everyone. Stop, attempt verbal de-escalation, and contact dispatch or law enforcement.",
  },
  {
    id: "sb038",
    question: "Students on a school bus are required to:",
    options: [
      "Sit in assigned seats and follow the driver's instructions",
      "Sit anywhere they choose",
      "Only remain seated if the driver requests it",
      "Wear seat belts only on highways",
    ],
    answer: 0,
    explanation: "Students must follow the driver's instructions, remain seated when the bus is moving, and comply with district conduct policies.",
  },
  // ── SAFE HAVEN ───────────────────────────────────────────────────────────────
  {
    id: "sb039",
    question: "A 'safe haven' for a school bus refers to:",
    options: [
      "A specially marked parking spot at the school",
      "A pre-identified location (police station, fire station, school) where the driver can go during a threat or emergency",
      "A bus maintenance facility",
      "Any public building",
    ],
    answer: 1,
    explanation: "A safe haven is a pre-selected secure location — such as a police or fire station — where the driver can take the bus if threatened or in an emergency requiring a safe stop.",
  },
  {
    id: "sb040",
    question: "If a school bus driver feels threatened by a person outside the bus, they should:",
    options: [
      "Open the door to confront the person",
      "Drive to the nearest safe haven and notify dispatch and law enforcement",
      "Stop and wait for the threat to go away",
      "Allow students to call their parents",
    ],
    answer: 1,
    explanation: "Do not open the door to a threat. Drive to the nearest safe haven (police station, fire station) while notifying dispatch and calling 911.",
  },
  // ── ABS AND BRAKING ───────────────────────────────────────────────────────────
  {
    id: "sb041",
    question: "School buses equipped with anti-lock braking systems (ABS) should be braked during an emergency by:",
    options: [
      "Pumping the brakes rapidly",
      "Applying firm, steady pressure — ABS automatically prevents wheel lockup",
      "Pressing the brake pedal in short bursts",
      "Applying very light pressure to keep wheels rolling",
    ],
    answer: 1,
    explanation: "With ABS, apply firm continuous pressure. The system pulses automatically to prevent lockup while maintaining steering control — do not pump ABS-equipped brakes.",
  },
  {
    id: "sb042",
    question: "An ABS malfunction light illuminates on a school bus while driving. You should:",
    options: [
      "Stop immediately — the bus has no brakes",
      "Continue driving — ABS is a backup system and normal brakes still work",
      "Pump the brakes to restore ABS",
      "Park and refuse to move until the ABS is repaired",
    ],
    answer: 1,
    explanation: "ABS is a supplemental system. If ABS fails, normal (foundation) brakes still work. Report the defect, complete the trip safely, and arrange for repair before the next run.",
  },
  // ── APPROACHING STOPS ─────────────────────────────────────────────────────────
  {
    id: "sb043",
    question: "When approaching a student bus stop, how far in advance should the driver activate the amber (yellow) flashing lights?",
    options: [
      "Immediately upon seeing the stop",
      "100 to 500 feet before the stop, depending on the posted speed limit",
      "Exactly 50 feet before the stop",
      "Only after stopping the bus",
    ],
    answer: 1,
    explanation: "Amber lights must be activated 100–500 feet before the stop (more distance at higher speeds) to warn approaching traffic before the red lights and stop arm activate.",
  },
  {
    id: "sb044",
    question: "The correct sequence when approaching a student loading stop is:",
    options: [
      "Stop → Open door → Activate red lights → Extend stop arm",
      "Activate amber lights → Stop 15+ feet from curb → Activate red lights → Extend stop arm → Check mirrors → Open door",
      "Activate red lights → Stop → Open door → Check mirrors",
      "Check mirrors → Stop → Open door → Activate lights",
    ],
    answer: 1,
    explanation: "Activate amber lights while approaching, come to a complete stop, then activate red lights and extend the stop arm, check all mirrors, and only then open the door.",
  },
  {
    id: "sb045",
    question: "How close to the curb should a school bus stop when loading or unloading at a curbside stop?",
    options: [
      "Exactly 3 feet from the curb",
      "As close to the curb or edge as safely possible to keep students out of traffic",
      "At least 6 feet from the curb",
      "In the center of the travel lane",
    ],
    answer: 1,
    explanation: "Stop as close to the curb or edge as safely possible so students do not have to step into the roadway to board or exit the bus.",
  },
  // ── STUDENT CROSSING PROCEDURES ───────────────────────────────────────────────
  {
    id: "sb046",
    question: "Before signaling students to cross in front of the bus, the driver must:",
    options: [
      "Wave immediately after the bus stops",
      "Verify that ALL traffic in both directions has completely stopped and it is safe to cross",
      "Only check the left side mirror",
      "Wait 10 seconds after stopping",
    ],
    answer: 1,
    explanation: "Confirm that all traffic has stopped on both sides before giving the crossing signal. A driver waving students into moving traffic is responsible for any resulting injury.",
  },
  {
    id: "sb047",
    question: "A student who needs to cross the road signals they are ready to cross. You notice a car that has not yet stopped. You should:",
    options: [
      "Wave the student across — the car will stop",
      "Hold the student back until all traffic has stopped",
      "Honk at the car and wave the student across",
      "Flash the headlights at the car and allow the student to cross",
    ],
    answer: 1,
    explanation: "Never wave a student into the roadway until you have confirmed every vehicle has stopped. One moving vehicle is enough to cause a fatality.",
  },
  {
    id: "sb048",
    question: "When can the driver deactivate the red lights and retract the stop arm after unloading?",
    options: [
      "As soon as the last student steps off the bus",
      "After all students are safely away from the bus, no student is crossing the road, and the driver confirms it is safe to go",
      "After 30 seconds have passed since the last student exited",
      "Once the door is closed",
    ],
    answer: 1,
    explanation: "Keep red lights on and stop arm extended until all students are safely away from the bus and the crossing is clear. Only then deactivate the lights and proceed.",
  },
  // ── BACKING A SCHOOL BUS ──────────────────────────────────────────────────────
  {
    id: "sb049",
    question: "Backing a school bus with students on board should be:",
    options: [
      "Done quickly to save time",
      "Avoided whenever possible — back only when absolutely necessary, after physically checking the rear area",
      "Performed using only mirrors",
      "Done at any speed less than 5 mph",
    ],
    answer: 1,
    explanation: "Backing is the most dangerous school bus maneuver. Avoid it whenever possible. When it is unavoidable, get out and walk around the bus to clear the area before backing.",
  },
  {
    id: "sb050",
    question: "Before backing a school bus, the driver should:",
    options: [
      "Sound the horn and begin backing",
      "Use only the rearview mirrors",
      "Physically exit the bus and walk around to check the rear and sides for children or obstacles",
      "Ask a student to watch out the rear window",
    ],
    answer: 2,
    explanation: "Always do a walk-around before backing. Children may be directly behind the bus in a blind spot that mirrors cannot cover.",
  },
  // ── SPECIAL SITUATIONS ────────────────────────────────────────────────────────
  {
    id: "sb051",
    question: "A student with a disability who uses a wheelchair should be boarded:",
    options: [
      "Last, after all other students, to avoid slowing boarding",
      "First or last consistently, following district policy, using the lift and proper securement",
      "Only on specially equipped school buses with a second aide present",
      "On the regular bus only if the parents sign a waiver",
    ],
    answer: 1,
    explanation: "Follow district policy and ADA requirements. Use the lift properly, allow adequate time, and fully secure the wheelchair with at least four anchor points before moving.",
  },
  {
    id: "sb052",
    question: "If a school bus stalls on a railroad track with students on board, the driver must:",
    options: [
      "Stay in the bus and call for a tow",
      "Attempt to restart the engine while monitoring for trains",
      "Immediately evacuate all students away from the tracks and move them perpendicular to the tracks",
      "Set out warning triangles and wait",
    ],
    answer: 2,
    explanation: "Get all students off the bus immediately. Move them away from the tracks in the direction from which a train might come — perpendicular to the tracks so they are not struck by debris.",
  },
  {
    id: "sb053",
    question: "If a school bus is involved in an accident, the driver's first priority is to:",
    options: [
      "Contact the bus company's insurance",
      "Check for and address student injuries while securing the bus and calling 911",
      "Move the bus off the road",
      "File a police report before helping students",
    ],
    answer: 1,
    explanation: "Student safety is always first. Secure the bus (parking brake), assess student injuries, call 911, and do not move injured students unless there is immediate danger.",
  },
  {
    id: "sb054",
    question: "When a school bus is stopped in heavy fog or low visibility with students loading, the driver should:",
    options: [
      "Turn off all lights to avoid confusing other drivers",
      "Activate hazard lights in addition to the standard stop arm lights",
      "Skip the stop and continue to the school",
      "Only use the stop arm",
    ],
    answer: 1,
    explanation: "In low visibility, use every available light (hazard, strobe if equipped, plus standard red lights and stop arm) to make the bus as visible as possible to approaching traffic.",
  },
  {
    id: "sb055",
    question: "Students who are not picked up at their scheduled stop because the bus passed them should:",
    options: [
      "Walk to school — it is their responsibility to be on time",
      "Be reported to dispatch; the driver should not back up the bus to retrieve them",
      "Be allowed to flag down the bus from the road",
      "Be ignored until the next school day",
    ],
    answer: 1,
    explanation: "Do not back up the bus — backing is dangerous. Report missed students to dispatch so alternate arrangements can be made.",
  },
  // ── REGULATIONS AND REQUIREMENTS ──────────────────────────────────────────────
  {
    id: "sb056",
    question: "To operate a school bus carrying students, a driver must hold at minimum:",
    options: [
      "A Class C license",
      "A Class B or Class A CDL with a Passenger (P) endorsement AND a School Bus (S) endorsement",
      "A Class B CDL with only the Passenger endorsement",
      "Any CDL regardless of class",
    ],
    answer: 1,
    explanation: "Drivers of school buses carrying more than 15 passengers (including driver) must hold a CDL with both the P (Passenger) and S (School Bus) endorsements.",
  },
  {
    id: "sb057",
    question: "The School Bus (S) endorsement requires the driver to pass:",
    options: [
      "Only a written knowledge test",
      "A written knowledge test AND a skills test in a school bus",
      "Only a skills test",
      "No additional test beyond the Passenger endorsement",
    ],
    answer: 1,
    explanation: "The S endorsement requires both a written knowledge test covering school bus operations AND a skills test (pre-trip inspection, backing, loading/unloading) conducted in a school bus.",
  },
  {
    id: "sb058",
    question: "School buses must be painted a specific color because:",
    options: [
      "It is a federal highway design standard",
      "National School Bus Yellow is required by federal and state regulations — it is the most visible color in all lighting conditions",
      "Yellow is the cheapest paint available",
      "It helps students locate the bus from a distance",
    ],
    answer: 1,
    explanation: "National School Bus Yellow (or Chrome Yellow) is required by law for its high visibility. Studies show it is the most recognizable color in poor light and peripheral vision.",
  },
  {
    id: "sb059",
    question: "Which of the following is a school bus driver prohibited from doing while driving with students on board?",
    options: [
      "Using the PA system",
      "Using a hand-held cell phone or texting",
      "Adjusting the mirrors",
      "Activating the stop arm at a stop",
    ],
    answer: 1,
    explanation: "Federal regulations prohibit use of hand-held mobile devices while operating any CMV, including school buses. Violations carry heavy fines and CDL penalties.",
  },
  {
    id: "sb060",
    question: "A school bus driver's criminal background check must be conducted:",
    options: [
      "Only at initial hire",
      "At initial hire and periodically (annually in most states) thereafter",
      "Every 5 years",
      "Only when requested by school administration",
    ],
    answer: 1,
    explanation: "Most states require ongoing background checks for school bus drivers. Initial and annual (or periodic) checks are required because drivers are responsible for children's safety.",
  },
  // ── GENERAL SCHOOL BUS SAFETY ────────────────────────────────────────────────
  {
    id: "sb061",
    question: "Students should be taught to establish eye contact with the bus driver before crossing because:",
    options: [
      "It lets the driver know they are ready to cross",
      "It confirms the driver can see them and is aware they are about to cross",
      "It is a school courtesy rule",
      "It is required by federal law",
    ],
    answer: 1,
    explanation: "Eye contact confirms mutual awareness. The driver gives a clear signal only after seeing the student and verifying it is safe. This two-way confirmation prevents accidents.",
  },
  {
    id: "sb062",
    question: "What should a student do if they drop something and it rolls under the school bus?",
    options: [
      "Retrieve it immediately before the bus drives away",
      "Leave it and tell the driver — never reach under or near the bus",
      "Ask a friend to pick it up",
      "Wait until the bus leaves and then retrieve it",
    ],
    answer: 1,
    explanation: "Students must never reach under the bus. They should tell the driver, who can then safely retrieve the item or make arrangements.",
  },
  {
    id: "sb063",
    question: "When a school bus is on a highway and a student becomes seriously ill, the driver should:",
    options: [
      "Speed to the hospital",
      "Pull over safely to the right shoulder, activate hazard lights, call 911, and provide first aid within your training",
      "Drop all other students first before going to the hospital",
      "Continue to the school and let the school nurse handle it",
    ],
    answer: 1,
    explanation: "Pull over, call 911, and provide aid. Do not drive at excessive speed — the risk of an accident outweighs the time saved. Emergency services will respond faster.",
  },
  {
    id: "sb064",
    question: "How far from the school building entrance should a school bus stop to discharge students?",
    options: [
      "As close as possible — right at the door",
      "At least 10 feet from the entrance, in the designated school bus loading zone, following district policy",
      "At least 100 feet from the entrance for safety",
      "Anywhere in the school parking lot",
    ],
    answer: 1,
    explanation: "Stop in the designated loading zone following your school district's traffic management plan. Pulling too far away or too close can create congestion and safety hazards.",
  },
  {
    id: "sb065",
    question: "Who is responsible for the safety of students from the time they board the school bus until they exit at their destination?",
    options: [
      "The school principal only",
      "The bus driver — from the moment students board until they safely exit at their stop or school",
      "Parents are responsible until the school building door",
      "The school district liability insurance",
    ],
    answer: 1,
    explanation: "The bus driver is legally and professionally responsible for student safety during the entire trip — from boarding at the stop to exiting at the destination.",
  },
];

export default schoolBus;
